import { ProcessedDocument } from '../types/document-upload'

export enum DocumentActions {
  ADD = 'add',
  REMOVE = 'remove',
  SET_UPLOADED = 'setUploaded',
  SET_DESCRIPTION = 'setDescription',
  RESET = 'reset',
}

interface DocumentActionBase {
  document: ProcessedDocument
}
interface AddDocumentAction extends DocumentActionBase {
  type: DocumentActions.ADD
}

interface RemoveDocumentAction {
  type: DocumentActions.REMOVE
  id: string
}

interface SetUploadedDocumentAction extends DocumentActionBase {
  type: DocumentActions.SET_UPLOADED
  id: string
}

interface ResetDocumentAction {
  type: DocumentActions.RESET
}

export type DocumentUploadActions =
  | AddDocumentAction
  | RemoveDocumentAction
  | SetUploadedDocumentAction
  | ResetDocumentAction
